module.exports = __webpack_public_path__ + "img/icon-wsc@2x.ef4b0e11.png";